<template>
<div class="furnish-main">
  <div style="margin-bottom: 5px;">
    <el-button size="mini" type="success" @click="startFlow" :disabled="allow">发起完结流程</el-button>
    <el-button size="mini" type="warning" v-if="form.complete_task_id" @click="lookFlow">查看流程</el-button>
  </div>
  <el-descriptions title="" :column="1" border label-style="width: 120px;">
    <el-descriptions-item label="业主身份证">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="业主身份证" ></FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="银行卡">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="银行卡" ></FitmentFileSubgroup>
    </el-descriptions-item>
  </el-descriptions>
</div>
</template>

<script>
import FitmentFileSubgroup from "./components/FitmentFileSubgroup";
export default {
  name: "DepositSettlement",
  components: {FitmentFileSubgroup},
  inject:['mainObj','componentId','setComponentId','ProcessState','setProcessState'],
  data(){
    return{
      form:{},
      allow: true
    }
  },
  mounted() {
    this.getData()
  },
  methods:{
    getData(){
      const that = this;
      ERP.postRequest({url:"admin/HouseFurnish/getFurnish",data:{house_id:that.mainObj.house_id,id:that.mainObj.id}},ret=>{
        if(ret.code){
          that.form=ret.data;
          if(ret.data.ProcessState==4) {
            that.allow = false
          }
          if(ret.data.complete_task_id) {
            that.allow = true
          }
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
      completeFurnish() {
        const that = this;
        if(that.mainObj.id != '') {
          this.$confirm('是否确认完结, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            ERP.postRequest({url:"admin/HouseFurnish/setProcessState",data:{id:that.mainObj.id,ProcessState:6}},ret=>{
              if(ret.code){
                this.$msgbox.alert(ret.msg||"操作成功")
              }else{
                this.$msgbox.alert(ret.msg||"查询失败")
              }
            })

          }).catch(() => {
            // this.$message({type: 'info',message: '已取消'});
          });
        }

      },
      sureSet(file_name) {
        window.open('/#/order/deposit', '_blank');
        // let url=AppConfig.erp_server+"/excel/house/"+file_name;
        // window.open(url, "_blank");
      },
      startFlow(){
        const that=this;
        let timeValue=(new Date()).getTime();
        ERP.navigateTo(`/flow/FlowView?sheet_id=169&master_id=136&house_id=${that.form.HouseID}&fitment_id=${that.form.ID}&timeValue=${timeValue}`)
      },
      lookFlow(){
        const that=this;
        let timeValue=(new Date()).getTime();
        ERP.navigateTo(`/flow/FlowView?sheet_id=169&master_id=136&task_id=${that.form.complete_task_id}`)
      },
  }
}
</script>

<style lang="scss" scoped>
@import url(../../common.scss);
.furnish-main{
  height: calc(100vh - 230px);
  overflow-y: scroll;
  .el-link-common{
    margin-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/DepositSettlement.vue